import React from 'react';
import PropTypes from 'prop-types';
import SortableTable from '../SF/table/SortableTable';
import InterventionListTableRow from './InterventionListTableRow';
import InterventionListIntervention from './InterventionListIntervention';
import { getTenantConfig, getWord } from 'utils/tenant';
import { withLoader } from '../common/withLoader';
import SelectAllCheckbox from '../SF/table/SelectAllCheckbox';

class InterventionListTable extends React.Component {

  get headers() {
    return [{
      content: <SelectAllCheckbox
        itemName={this.props.itemName}
        itemIds={this.props.interventions.map(item => item.id)}
        batchSelectAllEnabled={getTenantConfig('BATCH_ACTION_PROCESSING_ENABLED')}
        selectAllItems={this.props.selectAllInterventions} 
        selectedItemIds={this.props.selectedInterventions} 
        totalItemCount={this.props.totalInterventions} />,
      collapsing: true
    }, {
      content: 'Student',
      sortValue: 'studentName',
      width: 2
    },
        ...(getTenantConfig('SUCCESS_SCORE_ENABLED') ? [{
            content: getWord('successScore'),
            sortValue: 'successScore',
            width: 1
        }] : []
    ), {
      content: 'Item Name',
      sortValue: 'name',
      width: 4
    }, {
      content: 'Status',
      sortValue: 'status'
    }, {
      content: 'Created Date',
      sortValue: 'raiseDate'
    }, {
      content: 'Resolved Date',
      sortValue: 'clearDate'
    },
      ...(getTenantConfig('ASSIGN_TRACKING_ITEM_ENABLED') ? [{
          content: 'Assigned To',
          sortValue: 'assignedTo'
        }] : []
      ), {
        content: 'Due',
        sortValue: 'dueDate'
      }];
  }

  renderIntervention = (intervention, index) =>
    <InterventionListTableRow 
      getStudentFolderLink={this.props.getStudentFolderLink}
      getSuccessScoreRange={this.props.getSuccessScoreRange}
      key={index}
      intervention={new InterventionListIntervention(intervention, this.props.userCanSeeSuccessScore)}
      interventionIsSelected={this.props.selectedInterventions.findIndex(
        selectedInterventionId => selectedInterventionId === intervention.id) > -1}
      selectIntervention={(checked) => this.props.selectInterventions(checked, [intervention.id])} />

  render() {
    return <SortableTable 
      columnToSort={this.props.columnToSort}
      headers={this.headers}
      items={this.props.interventions}
      itemsPerPage={this.props.interventionsPerPage}
      onPageChange={this.props.onPageChange}
      onSortChange={this.props.onSortChange}
      renderItem={this.renderIntervention}
      start={this.props.start}
      sortDirection={this.props.sortDirection}
      totalItems={this.props.totalInterventions}
      totalSelected={this.props.selectedInterventions.length} />
  }

  componentDidUpdate() {
    SF.card.rebindAllCards();
  }

}

InterventionListTable.defaultProps = {
  columnToSort: 'raiseDate',
  itemName: 'Items',
  sortDirection: 'descending'
};

InterventionListTable.propTypes = {
  getStudentFolderLink: PropTypes.func.isRequired,
  getSuccessScoreRange: PropTypes.func.isRequired,
  columnToSort: PropTypes.string.isRequired,
  interventions: PropTypes.array.isRequired,
  interventionsPerPage: PropTypes.number.isRequired,
  itemName: PropTypes.string.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  selectAllInterventions: PropTypes.func.isRequired,
  selectedInterventions: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectInterventions: PropTypes.func.isRequired,
  sortDirection: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  totalInterventions: PropTypes.number.isRequired,
  userCanSeeSuccessScore: PropTypes.bool.isRequired
};

export default withLoader(InterventionListTable);
